import { addApiPrefix } from 'as-ui-kit/utils/urls';
import { getFetchOptions, handleResult } from 'as-ui-kit/utils/http';
import { snakeToPascalObj, camelToSnakeObj } from 'as-ui-kit/utils/adapters';
import { catchWithMsg } from 'utils/http';
import {geoServiceUrlPrefix} from 'urls';

export const searchGeo = (rq, appUrl) =>
    fetch(addApiPrefix('/public/extendedsearch/v1/geo', appUrl), getFetchOptions(camelToSnakeObj(rq), 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const getCitiesByIds = (ids) =>
    fetch(addApiPrefix('cities/by-ids', geoServiceUrlPrefix), getFetchOptions({ids: [...new Set(ids)]}, 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const getRegionsByIds = (ids) =>
    fetch(addApiPrefix('regions/by-ids', geoServiceUrlPrefix), getFetchOptions({ids: [...new Set(ids)]}, 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const getCountriesByIds = (ids) =>
    fetch(addApiPrefix('countries/by-ids', geoServiceUrlPrefix), getFetchOptions({ids: [...new Set(ids)]}, 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);
